export const INSTRUCTIONS_PAGE_NUM = 0;
export const OPERATIONS_PAGE_NUM = 1;
export const MUTIPLY_PAGE_NUM = 5;
export const PAGE_IDS = [
  "#instructions",
  "#operations",
  "#inverse-sec",
  "#rank",
  "#determinant",
  "#multiply",
];
